import RestAPI from 'src/common/RestApi'

export function updateExternalConnectionsApi(links) {
  return RestAPI.updateWithFormData('/alpha/organization/external_connections', links)
}
